const x = {
  xxs: "320px",
  xs: "480px",
  sm: "640px",
  md: "768px",
  "2md": "860px",
  lg: "1024px",
  xl: "1280px",
  "2xl": "1315px",
  "3xl": "1536px",
  "4xl": "1600px",
  "5xl": "1920px",
  "6xl": "2500px",
  "max-xxs": { max: "319px" },
  "max-xs": { max: "479px" },
  "max-sm": { max: "639px" },
  "max-md": { max: "767px" },
  "max-2md": { max: "859px" },
  "max-lg": { max: "1023px" },
  "max-xl": { max: "1279px" },
  "max-2xl": { max: "1314px" },
  landscape: { raw: "(orientation: landscape)" }
};
export {
  x as mediaBreakpoints
};
